'use strict';

export default class Video {
  constructor() {

  	let $video = $('.jp-video'),
  		videoSrc = $video.attr('data-video'),
  		videoPoster = $video.data('poster');

  	if (!$video.length) {
        return false;
    }

    $("#jquery_jplayer_1").jPlayer({

		ready: function () {
			$(this).jPlayer("setMedia", {
				m4v: videoSrc,
				mp4: videoSrc,
				poster: videoPoster
			});
		},
		supplied: "mp4, m4v",
		size: {
			width: "100%",
			height: "360px",
			cssClass: "jp-video-360p"
		},
		useStateClassSkin: true,
		autoBlur: false,
		smoothPlayBar: true,
		keyEnabled: true,
		remainingDuration: true,
		toggleDuration: true
	});
  }
}
